import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CourseSuggestion } from '../models/course-search-autosuggest.models';
import { EnvironmentApiService } from '@uc/web/config';
import { DegreeLevelPayload } from '@uc/web/shared/data-models';
import { DegreeLevelService } from '@uc/web/shared/data-access';

@Injectable({ providedIn: 'root' })
export class CourseSearchAutosuggestApiService {
	constructor(
		private _http: HttpClient,
		private _degreeLevelSrv: DegreeLevelService,
		private _apiSrv: EnvironmentApiService,
	) {}

	getCourseSuggestions(value: string, degreeLevel: DegreeLevelPayload) {
		const API = this.getCourseSuggestionAPI();

		return this._http.get<CourseSuggestion[]>(
			`${this._apiSrv.API_URL}${API}?query=${value}&degree_level=${degreeLevel}`,
		);
	}

	getCourseSuggestionAPI() {
		return this._degreeLevelSrv.shouldQueryClearingAPI()
			? 'clearing/course-suggestions'
			: 'course-suggestions';
	}
}
